import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { PlatformAuthProvider } from './platform-auth'
import { ConfirmationProvider } from './confirmation'
import './styles.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><BrowserRouter><PlatformAuthProvider><ConfirmationProvider><App /></ConfirmationProvider></PlatformAuthProvider></BrowserRouter></React.StrictMode>,
)
